export const TableHeader = [
    {className: '', name: 'Trials'},
    {className: '', name: 'Paid trials'},
    {className: '', name: 'Trial to Sub'},
    {className: '', name: 'Direct sub'},
    {className: 'position', name: 'ARPU'},
    {className: 'position', name: 'ARPUe'},
    {className: 'position', name: 'ARPU Ad 1 day'}
];

export default TableHeader;